import { render, staticRenderFns } from "./HomeButton.vue?vue&type=template&id=cc9bc660&scoped=true&"
import script from "./HomeButton.vue?vue&type=script&lang=js&"
export * from "./HomeButton.vue?vue&type=script&lang=js&"
import style0 from "./HomeButton.vue?vue&type=style&index=0&id=cc9bc660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9bc660",
  null
  
)

export default component.exports